var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty",class:{'is-loading': _vm.loading}},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.loading)?_c('i',{staticClass:"empty-icon fa fa-spinner fa-spin"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }